export default __webpack_public_path__ + "static/about-decor-4-ed75d77bf901a1da0a7f086816bc9864.png";